module.exports = __webpack_public_path__ + "img/profile_box_gray_age_range.782bdb7d.svg";